import http from '@/http'
import User from '@/store/models/User'

const API_PATH = 'organizations/:organizationId/user_organization/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async create({ commit }, payload) {
    const { organizationId, inviteToken } = payload
    const apiPath = configureApiPath({ organizationId: organizationId })
    const params = JSON.stringify({
      userOrganization: {
        inviteToken: inviteToken
      }
    })
    await http.post(apiPath, params).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async update({ commit, rootGetters }, payload) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    await http.put(apiPath, payload).then(response => {
      User.update({
        where: rootGetters['auth/signedInUser'].id,
        data (user) {
          user.favoriteUsers = response.data.included.filter(resource => resource.type === 'userFavoriteUser').map(user => {
            return {
              id: user.attributes.id,
              userId: user.attributes.userId,
              listSequenceNo: user.attributes.listSequenceNo
            }
          })
          user.meta.userLabel = response.data.data.attributes.userLabel
        }
      })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
